'use client';
import Image from "next/image";
import Link from "next/link";
import styles from "@/app/styles/dine.module.scss";
import useDeviceType from "@/app/utils/useDeviceType";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Carousel } from 'react-bootstrap';
import https from "https";
import { useState, useEffect } from "react";
import { Tabs, Tab } from 'react-bootstrap';
import Loading from "./loading";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import CodeDisplay from "@/app/utils/content";

const agent = new https.Agent({
  rejectUnauthorized: false,
});

async function getPageData() {
  const query = `
{
  pageData: pageBy(id: "cG9zdDoxMzI=") {
    pageBan {
      bannerText
      bannerSlider {
        desktopImage {
          node {
            mediaItemUrl
          }
        }
      }
    }
  }
  taxgallerys {
    nodes {
      slug
      name
    }
  }
  qlgalleries {
    nodes {
      galleryAll {
        gallery(first: 50) {
          nodes {
            mediaItemUrl
          }
        }
      }
      taxgallerys {
        nodes {
          slug
          name
        }
      }
      videos {
        videoFeaturedImage {
          node {
            mediaItemUrl
          }
        }
        videoUrl
      }
    }
  }
}
  `;

  const res = await fetch(
    `${process.env.NEXT_PUBLIC_GRAPHQL_ENDPOINT}`,
    {
      httpsAgent: agent,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({query}),
      next: {
        revalidate: 60,
      },
    }
  );

  const { data } = await res.json();

  return data;
}

export default function Gallery() {

  const deviceType = useDeviceType();

  const [page_data, setPageData] = useState(null);

  const [page_banner_text, setPageBannerText] = useState("");
  const [page_banner_sliders, setPageBannerSliders] = useState([]);

  const [ent_list, setEntList] = useState([]);
  const [ent_all, setEntAll] = useState([]);
  const [type_list, setTypeList] = useState([]);

  const [showVideoModal, setShowVideoModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [currentImages, setCurrentImages] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [videoUrl, setVideoUrl] = useState('');

  const [pre_loader_enabled, setPreLoaderEnable] = useState(true);

  const openVideoModal = (url) => {
   // console.log(url);
    setVideoUrl(url);
    setShowVideoModal(true);
  };

  const closeVideoModal = () => {
    setShowVideoModal(false);
  };

  const openModal = (images, index) => {
    setCurrentImages(images);
    setCurrentIndex(index);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % currentImages.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + currentImages.length) % currentImages.length);
  };

  useEffect(() => {

    const fetchData = async () => {
      const page = await getPageData();
      if(page){
       // console.log(page);
        setPageData(page);
        if(page.pageData){

          if(page.pageData.pageBan){
            if(page.pageData.pageBan.bannerText){
              setPageBannerText(page.pageData.pageBan.bannerText);
            }
            if(page.pageData.pageBan.bannerSlider){
              setPageBannerSliders(page.pageData.pageBan.bannerSlider);
            }
          }

        }

        if(page.qlgalleries){
          if(page.qlgalleries.nodes){
            setEntAll(page.qlgalleries.nodes);
          }
        }

        if(page.taxgallerys){
          if(page.taxgallerys.nodes){
            setTypeList(page.taxgallerys.nodes);
          }
        }
        setPreLoaderEnable(false);
      }
    };

    fetchData();
    return () => {};
  }, []);


  useEffect( () => {
    (
      async () => {
          const LocomotiveScroll = (await import('locomotive-scroll')).default
          const locomotiveScroll = new LocomotiveScroll();
      }
    )()
  }, [])


  if (pre_loader_enabled) {
    return <Loading />;
  }
  return (
    <>
      {page_banner_sliders && page_banner_sliders.length !== 0 &&(
      <section className="inner-banner position-relative">
        <Carousel fade className='page-inner-carousel'>
        {page_banner_sliders.map((banner_img, index) => {

          let imgurl = '';

          if(banner_img.desktopImage){
            if(banner_img.desktopImage.node){
              if(banner_img.desktopImage.node.mediaItemUrl){
                imgurl = banner_img.desktopImage.node.mediaItemUrl;
              }
            }
          }

          return(
          <Carousel.Item key={index}>
            <Image
              className={styles.banner_section_main_img}
              src={imgurl}
              width={deviceType !== "mobile" ? 1920 : 400}
              height={deviceType !== "mobile" ? 1080 : 800}
              alt="Banner Image"
              priority
              quality={deviceType !== "mobile" ? 50 : 80}
            />
          </Carousel.Item>
          );}
          )}
        </Carousel>
        <div className='inner-banner-text'>
          <h2 className='all-caps section-heading-large section-heading--white'>{page_banner_text}</h2>
        </div>
      </section>
      )}
      {page_banner_sliders && page_banner_sliders.length === 0 &&(
      <section className="bg-dark-meroon green-mesh  inner-banner-text-wrap position-relative">
        <div className='inner-banner-text z-top'>
          <h6 className="creative-heading-small creative-heading--white all-caps para-light">
            {page_banner_text}
          </h6>        
          <h1 className='all-caps section-heading-large section-heading--white m-0 mob-title'>visual vibes</h1>
        </div>
      </section>
      )}

{/* new design Chamini */}



{/* end new design chamini */}


    <section className="p-t-i-60 section-padding-bottom bg-dark-meroon green-mesh ">
      <div className="main-wrapper z-top">
        <Tabs defaultActiveKey="all" id="offer-tabs" className="offer-tabs galleryTabs">
          {type_list.map((type_item, indextop) => {

            let filteredarray = [];

            filteredarray = ent_all.filter(item => item.taxgallerys && item.taxgallerys.nodes.some(node => node.slug === type_item.slug));
            //console.log('filter',filteredarray);
            
          return(
          <Tab eventKey={type_item.slug} title={type_item.name} key={indextop}>
            {type_item.slug !== 'videos' &&(<>
            <div className="">
              <div className={`gallery-div-wrap`}>
                {filteredarray.map((all_item, indexi) => {

                  let gallery = [];

                  if(all_item.galleryAll){
                    if(all_item.galleryAll.gallery){
                      if(all_item.galleryAll.gallery.nodes){
                        gallery = all_item.galleryAll.gallery.nodes;
                      }
                    }
                  }
                  
                return(
                <div className={styles.offer_inner_box_wrap} key={indexi}>
                  {gallery.map((gal_item, indexbottom) => (
                  <div className="gallery-div" key={indexbottom}>
                    <Image
                        src={gal_item.mediaItemUrl}
                        width={deviceType !== "mobile" ? 500 : 400}
                        height={deviceType !== "mobile" ? 400 : 300}
                        alt="Banner Image"
                        onClick={() => openModal(gallery, indexbottom)}
                      />
                  </div>
                  )
                  )}
                </div>
                );}
                )}
                
              </div>
              {filteredarray.length === 0 &&(
                <div className="text-center w-100 d-flex justify-content-center">
                    <p className="paragraph paragraph--white text-center">No {type_item.name} Gallery</p>
                </div>
              )}
            </div>
            <Modal show={showModal} onHide={closeModal} className="gallery-box" centered>
              <Modal.Header closeButton></Modal.Header>
              <Modal.Body>
                <div className="modal-content modal-lightbox">
                  <div className="d-flex align-items-center justify-content-between">
                    <Button className="prev-btn-modal btn-light" onClick={prevSlide}>
                      <Image
                        className="branch-box-img"
                        height={50}
                        width={50}
                        src="/w-left.png"
                        alt="Previous"
                      />
                    </Button>
                    <div className="mySlides">
                      <Image
                        src={currentImages[currentIndex]?.mediaItemUrl}
                        alt="Current Slide"
                        width={deviceType !== "mobile" ? 1000 : 500}
                        height={deviceType !== "mobile" ? 1000 : 500}
                      />
                    </div>
                    <Button className="next-btn-modal btn-light" onClick={nextSlide}>
                      <Image
                        className="branch-box-img"
                        height={50}
                        width={50}
                        src="/w-right.png"
                        alt="Next"
                      />
                    </Button>
                  </div>
                </div>
              </Modal.Body>
            </Modal>
            </>)}
            {type_item.slug === 'videos' &&(
            <>
            <div className="video-wrap flex-wrap d-flex justify-content-center">
              {filteredarray.map((all_item, index) => {

                let video_url = "";

                if(all_item.videos){
                  if(all_item.videos.videoUrl){
                    video_url = all_item.videos.videoUrl;
                  }
                }

                return(
                <div className="video-box" key={index}>
                  <div className="video-box-inner" onClick={() => openVideoModal(video_url)}>
                      <Image
                        height={500}
                        width={500}
                        src="/home/ent.png"
                        alt="Previous"
                        
                      />
                  </div>
                </div>
                );}
                )}
            </div>
            <Modal show={showVideoModal} onHide={closeVideoModal} className="gallery-box" centered>
                <Modal.Header closeButton></Modal.Header>
                <Modal.Body>
                  <div className="modal-content modal-lightbox iframe-div">
                    {videoUrl && (
                      <CodeDisplay code={videoUrl} />
                    )}
                  </div>
                </Modal.Body>
              </Modal>
            </>
            )}
          </Tab>
          );})}
        </Tabs>
      </div>
    </section>
    </>
  )
}
